import { render, staticRenderFns } from "./SatsangiArrivalReport.vue?vue&type=template&id=53fc8de1&"
import script from "./SatsangiArrivalReport.vue?vue&type=script&lang=js&"
export * from "./SatsangiArrivalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports